import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    downloads: [],
    download: null,
    links: null,
    meta: null,
    filter: {
      keyword: null,
      type: null,
      productCategoryId: null,
      productId: null,
    },
    driveTypeOptions: [
      { value: 1, title: 'Datasheet' },
      { value: 2, title: 'Driver' },
      { value: 3, title: 'Manual' },
      { value: 4, title: 'Program' },
      { value: 5, title: 'e-Catalog' },
      { value: 6, title: 'EDM' },
      { value: 7, title: 'Logo' },
      { value: 8, title: 'White Paper' },
      { value: 9, title: 'Software' },
      { value: 10, title: 'Firmware' },
      { value: 11, title: 'Driver (Win 11)' },
      { value: 12, title: 'Chipset' },
      { value: 13, title: 'Graphics' },
      { value: 14, title: 'Bluetooth' },
      { value: 15, title: 'TouchPad' },
      { value: 16, title: 'Wireless LAN' },
      { value: 17, title: 'Ethernet' },
      { value: 18, title: 'Thunderbolt' },
      { value: 19, title: 'Intel Management Engine' },
      { value: 20, title: 'Tutorial' },
      { value: 21, title: 'Audio' },
      { value: 22, title: 'Serial I/O' },
      { value: 23, title: 'Utilities' },
      { value: 24, title: 'Card Reader' },
    ],
    tagOptions: [
      null,
      'Marketing Materials',
      'Technical Documents',
      'Software',
      'Drivers & Manuals',
    ],
  },

  mutations: {
    CLEAR_ALL(state) {
      state.filter = {
        keyword: null,
        type: null,
        productCategoryId: null,
        productId: null,
      };
      state.downloads = [];
      state.download = null;
    },
    SET_DOWNLOADS(state, data) {
      state.downloads = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_DOWNLOAD(state, data) {
      state.download = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setDownload({ commit }, data) {
      commit('SET_DOWNLOAD', data);
    },

    find({ commit, state }) {
      let url = `/product_downloads?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('ProductDownload'));
          return response.body;
        })
        .then((response) => {
          commit('SET_DOWNLOADS', response);
        });
    },

    findById({ commit }, id) {
      return http(`/product_downloads/${id}`)
        .then((response) => response.body)
        .then(typeAs('ProductDownload'))
        .then((item) => {
          commit('SET_DOWNLOAD', item);
        });
    },

    destroy(_, id) {
      return http(`/product_downloads/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/product_downloads/${id}`, { method: 'PUT', data })
        : http('/product_downloads', { method: 'POST', data });

      return request.then((response) => response.body);
    },
    allBySku(_, id) {
      return http(`/product_download_sku/${id}`)
        .then((response) => response.body);
    },
  },
};
